var $resourceMinErr = angular.$$minErr('$resource');

/**
 * Create a shallow copy of an object and clear other fields from the destination
 */
function shallowClearAndCopy(src, dst) {
    dst = dst || {};
    angular.forEach(dst, function(value, key){
        delete dst[key];
    });
    for (var key in src) {
        if (src.hasOwnProperty(key) && key.charAt(0) !== '$' && key.charAt(1) !== '$') {
            dst[key] = src[key];
        }
    }
    return dst;
}


//TODO jchamizo: observers on nested resources to detect if they are dirty or not, hence send in update
export default angular.module('ecResource', ['ng']).provider('$resource', function $resource() {
    var defaultHeaders = {};

    this.setDefaultHeaders = function (headers) {
        defaultHeaders = headers;
    };

    this.$get = ['$http', '$parse', '$injector', '$q', '$rootScope',
        function ($http, $parse, $injector, $q, $rootScope) {

            var DEFAULT_ACTIONS = {
                    'fetch':        {method: 'GET', ignoreCache: true},
                    'getOrFetch':   {method: 'GET'},
                    'query':        {method: 'GET', isArray: true},
                    'save':         {method: 'POST'},
                    'update':       {method: 'PATCH'}, // TODO Implement total UPDATE
                    'delete':       {method: 'DELETE'}
                },
                noop = angular.noop,
                forEach = _.forEach,
                extend = angular.extend,
                copy = angular.copy,
                isFunction = angular.isFunction,
                isObject = angular.isObject,
                isString = angular.isString,
                getter = function (obj, path) {
                    return $parse(path)(obj);
                },
                nullyValue = function (value) {
                    return (
                        value === undefined ||
                        value === null ||
                        (typeof value === 'string' && value.length === 0)
                    );
                };

            var defaultValidators = {
                min: function (resource, field, constraint, errorMsg) {
                    return nullyValue(field) || field >= constraint || errorMsg || 'validation.min';
                },
                max: function (resource, field, constraint, errorMsg) {
                    return nullyValue(field) || field <= constraint || errorMsg || 'validation.max';
                },
                maxLength: function (resource, field, constraint, errorMsg) {
                    // If no field is provided return true, we have a notnull validator
                    var valid = field ? (field.length <= constraint) : true;
                    return valid || errorMsg || 'validation.maxLength';
                },
                minLength: function (resource, field, constraint, errorMsg) {
                    // If no field is provided return true, we have a notnull validator
                    var valid = field ? (field.length >= constraint) : true;
                    return valid || errorMsg || 'validation.minLength';
                },
                notNull: function (resource, field, errorMsg) {
                    return !nullyValue(field) || errorMsg || 'validation.notNull';
                },
                integer: function (resource, field, errorMsg) {
                    var isInteger = typeof field === 'number' && isFinite(field) &&  Math.floor(field) === field;
                    return isInteger || defaultValidators.matches(resource, field,  /^(\-|\+)?\d+$/ , errorMsg || 'validation.integer');
                },
                positiveInteger: function (resource, field, errorMsg) {
                    var integerValue = (/^(\+)?\d+$/.test(field) && parseInt(field, 10));
                    return nullyValue(field) ||
                        (integerValue && integerValue > 0) ||
                        errorMsg ||
                        'validation.positiveInteger';
                },
                url: function(resource, field, errorMsg) {
                    var urlRegExp = /^((https?:\/\/)?|(www.))([[\da-z\][\da-z.\-]+)\.([a-z\.]{2,6})([\/\w \.-?]*)*\/?$/;
                    return defaultValidators.matches(resource, field,  urlRegExp , errorMsg || 'validation.url');
                },
                greaterThan: function (resource, field, constraint, errorMsg) {
                    var isNumber = defaultValidators.integer(resource, field);
                    if (isNumber === true && field) {
                        return parseInt(field, 10) > constraint  || errorMsg || 'validation.greaterThan';
                    }
                    return isNumber;
                },
                lessThan: function (resource, field, constraint, errorMsg) {
                    var isNumber = defaultValidators.integer(resource, field);
                    if (isNumber === true && field) {
                        return parseInt(field, 10) < constraint  || errorMsg || 'validation.lessThan';
                    }
                    return isNumber;
                },
                inBetween: function(resource, field, constraintA, constraintB, errorMsg) {
                    var less = defaultValidators.lessThan(resource, field, constraintB, errorMsg);
                    if (less === true && field) {
                        return parseInt(field, 10) > constraintA  ||
                            errorMsg ||
                            'validation.greaterThan';
                    }
                    return less;
                },
                noSpace: function (resource, field, errorMsg) {
                    return nullyValue(field) || (typeof field === 'string' && !/.*\s.*/.test(field)) || errorMsg || 'validation.noSpaces';
                },
                matches: function(resource, field, constraints, errorMsg) {
                    var valid = field === null ||
                        field === undefined ||
                        (
                            (typeof field === 'string') &&
                            (field.length === 0 || constraints.test(field))
                        ) ;

                    return valid || errorMsg || 'validation.matches';
                },
                email: function(resource, field, constraints, errorMsg) {
                    var emailRegExp = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
                    return nullyValue(field) || defaultValidators.matches(resource, field, emailRegExp, errorMsg || 'validation.email');
                },
                // Validates the given property again this.$property list. The this context
                // is the Resource instance so a valid classProperties: { property: [list]}
                // had to be defined to use this validator
                'in': function (resource, field, classPropName, errorMsg) {
                    return _.contains(resource.$static[classPropName], field) || errorMsg || 'validation.invalidType';
                }
            };

            /**
             * This method is intended for encoding *key* or *value* parts of query component. We need a custom
             * method becuase encodeURIComponent is too agressive and encodes stuff that doesn't have to be
             * encoded per http://tools.ietf.org/html/rfc3986:
             *    query       = *( pchar / '/' / '?' )
             *    pchar         = unreserved / pct-encoded / sub-delims / ':' / '@'
             *    unreserved    = ALPHA / DIGIT / '-' / '.' / '_' / '~'
             *    pct-encoded   = '%' HEXDIG HEXDIG
             *    sub-delims    = '!' / '$' / '&' / ''' / '(' / ')'
             *                     / '*' / '+' / ',' / ';' / '='
             */
            function encodeUriQuery(val, pctEncodeSpaces) {
                return encodeURIComponent(val).
                    replace(/%40/gi, '@').
                    replace(/%3A/gi, ':').
                    replace(/%24/g, '$').
                    replace(/%2C/gi, ',').
                    replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
            }

            /**
             * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
             * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
             * segments:
             *    segment       = *pchar
             *    pchar         = unreserved / pct-encoded / sub-delims / ':' / '@'
             *    pct-encoded   = '%' HEXDIG HEXDIG
             *    unreserved    = ALPHA / DIGIT / '-' / '.' / '_' / '~'
             *    sub-delims    = '!' / '$' / '&' / ''' / '(' / ')'
             *                     / '*' / '+' / ',' / ';' / '='
             */
            function encodeUriSegment(val) {
                return encodeUriQuery(val, true).
                    replace(/%26/gi, '&').
                    replace(/%3D/gi, '=').
                    replace(/%2B/gi, '+');
            }

            function formatUri(uri) {
                if (uri && uri.indexOf('?') < 0) {
                    uri = uri.replace(/\/?$/, '/');
                }
                return uri;
            }

            function Route(urlConf, defaults) {
                var template = this.template = urlConf.url + '#',
                    urlParams = this.urlParams = {};

                this.paramDefaults = urlConf.paramDefaults || {};
                this.defaults = defaults || {};
                forEach(template.split(/\W/), function (param) {
                    if (param && (new RegExp('(^|[^\\\\]):' + param + '\\W').test(template))) {
                        urlParams[param] = true;
                    }
                });
                this.decodeTemplate = template;
                this.template = template.replace(/\\:/g, ':');
            }

            Route.prototype = {
                formatUri: function (uri, params, strict) {
                    var self = this,
                        encodedVal,
                        endVal = '';

                    forEach(this.urlParams, function (_, urlParam) {
                        var val, param,
                            paramDefVal = self.paramDefaults[urlParam];
                        if (params.hasOwnProperty(urlParam)) {
                            val = params[urlParam];
                        } else if (paramDefVal && paramDefVal.charAt && paramDefVal.charAt(0) === '@') {
                            param = paramDefVal.substr(1);
                            val = params[param];
                        }
                        if (!val) {
                            val = self.defaults[urlParam];
                        }
                        if (angular.isDefined(val) && val !== null) {
                            encodedVal = encodeUriSegment(val);
                            uri = uri.replace(new RegExp(':' + urlParam + '(\\W)', 'g'), encodedVal + '$1');
                        } else if (!strict) {
                            uri = uri.replace(new RegExp('(\/?):' + urlParam + '(\\W)', 'g'),
                                function (match, leadingSlashes, tail) {
                                    if (tail.charAt(0) === '/') {
                                        return tail;
                                    }
                                    return leadingSlashes + tail;
                                });
                        } else if (new RegExp(':' + urlParam + '\\W').test(uri)) {
                            throw 'Incomplete url';
                        }
                    });

                    // set the uri
                    if (uri.indexOf('?') < 0) {
                        endVal = '/';
                    }
                    uri = uri.replace(/\/?#$/, endVal);
                    return uri;
                },

                setUrlParams: function (config, params) {
                    var self = this,
                        url = this.template;

                    if (config.ignoreParams) {
                        params = undefined;
                    }
                    // If a resource_uri is provided explicitly we get rid off the template pointer
                    if (params && params.resource_uri) {
                        url = params.resource_uri;
                        delete params.resource_uri;
                    }

                    params = params || {};

                    config.url = this.formatUri(url, params, false);

                    // set params - delegate param encoding to $http
                    forEach(params, function (value, key) {
                        if (!self.urlParams[key]) {
                            config.params = config.params || {};
                            config.params[key] = value;
                        }
                    });
                },

                // obtains url based on provided params. This is used when there is
                // no need to create a httpConfig object, and only returns an url
                // when it is complete and there are no params in the middle
                getUrl: function (params) {
                    var url = this.template;

                    params = params || {};
                    try {
                        url = this.formatUri(url, params, true);
                    } catch (err) {
                        url = undefined;
                    }
                    return url;
                },

                // Method that works opposite to get URL and means to decode an URL extracting
                // the parameters included given a template.
                decodeUrlParams: function (url) {
                    var self = this,
                        urlParams = {},
                        templateParams = [],
                        variableReplace = /(^|[^\\\\]):\w+(\W)/g,
                        urlMatcher = new RegExp(
                            this.decodeTemplate.replace(variableReplace, '$1(\\w+)$2')
                                .replace(variableReplace, '$1(\\w+)$2')
                                .replace(/\\:/g, ':')
                                .replace(/\/?#$/, '/?$')
                        ),
                        urlMatch = urlMatcher.exec(url);

                    forEach(this.decodeTemplate.split(/\W/), function (param) {
                        if (param && (new RegExp('(^|[^\\\\]):' + param + '\\W').test(self.decodeTemplate))) {
                            templateParams.push(param);
                        }
                    });

                    if (urlMatch) {
                        urlMatch = _.slice(urlMatch, 1);
                        forEach(urlMatch, function (match, index) {
                            var value = decodeURIComponent(match),
                                urlParam = templateParams[index],
                                defaultParam = self.paramDefaults[urlParam];

                            if (defaultParam && defaultParam.charAt(0) === '@') {
                                urlParam = defaultParam.substr(1);
                            }

                            urlParams[urlParam] = value;
                        });
                    }

                    urlParams.resource_uri = url;

                    return urlParams;
                }
            };

            // Tries to update cache with a resource in case the resource has a cache
            function updateCache(resource, data) {
                // no cache => nothing to do
                if (!resource.$cache || !resource.resource_uri) { return resource; }

                var cacheId = formatUri(resource.resource_uri),
                    resourceCached = resource.$cache.get(cacheId);

                if (resourceCached) {
                    // if cache already has a resource stored do not overwrite it
                    // since references in other scopes may be lost. Instead update
                    // the cached object with new information from the resource.
                    extend(resourceCached, data);
                } else {
                    resource.$cache.put(cacheId, resource);
                    resourceCached = resource;
                }
                return resourceCached;
            }

            function resourceFactory(config) {
                var actions = extend({}, DEFAULT_ACTIONS, config.actions || {}),
                    fields = config.fields,
                    cache = config.cache,
                    url = config.url,
                    paramDefaults = config.paramDefaults,
                    initFunction = config.init || noop,
                    preInitFunction = config.preInit || noop,
                    resourceDumper = config.resourceDumper,
                    validators = fields && _.transform(fields, function (map, conf, fieldname) {
                        if (_.has(conf, 'validators')) {
                            map[fieldname] = conf.validators;
                        }
                    }, {}),
                    observers = config.observers && _.mapValues(config.observers, function (obs) {
                        return obs instanceof Array ? obs : [obs];
                    }),
                    classProperties = config.classProperties,
                    // headers = config.headers,
                    route = new Route(config);

                // injecting constructors of other resources in Fields
                if (fields) {
                    forEach(fields, function (value) {
                        if (_.isObject(value)) {
                            if (_.isString(value.resource) && value.resource !== '$self') {
                                value.resource = $injector.get(value.resource);
                            }
                        }
                    });
                }

                function initializeResource(self, resource, value, builder) {
                    resource = typeof resource === 'function' && !resource.prototype.$isDirty ?
                        resource.call(self) :
                        resource;

                    resource = typeof resource === 'string' ? $injector.get(resource) : resource;

                    if (resource && !(value instanceof resource)) {
                        value = resource.getOrCreate(value, builder);
                    }

                    return value;
                }

                // initializes a defined field
                // based on parameters provided
                // - resource: indicates it is a nested resource
                // - is_array: indicates that it is not a single object but an array
                // - loader: method to transform data to inner object information
                function initializeField(self, fieldValue, fieldName, builder) {
                    var field = fields[fieldName];
                    if (_.isUndefined(field) ||
                            (_.isUndefined(fieldValue) && !field.isArray)) {
                        return undefined;
                    }

                    if (_.isNull(fieldValue)) {
                        return null;
                    }

                    if (field.isArray) {
                        fieldValue = fieldValue || [];

                        forEach(fieldValue, function (element, index) {
                            if (isFunction(field.loader)) {
                                fieldValue[index] = element = field.loader.apply(self, [element]);
                            }

                            fieldValue[index] = initializeResource(self, field.resource, element, builder);
                        });

                        // Setting observers for the Array when added, modified and deleted elements
                        $rootScope.$watchCollection(function () {
                            return fieldValue;
                        }, function (values) {
                            forEach(values, function (value, index) {
                                if (field.resource && !(value instanceof field.resource)) {
                                    value = field.resource.getOrCreate(value);
                                    self[fieldName][index] = value;
                                }
                            });
                            if (!field.avoidDump) {
                                var dirty = self.$dirty = self.$dirty || {};
                                dirty[fieldName] = self[fieldName];
                            }
                        });

                    } else {
                        if (isFunction(field.loader)) {
                            fieldValue = field.loader.apply(self, [fieldValue]);
                        }

                        fieldValue = initializeResource(self, field.resource, fieldValue, builder);
                    }

                    return fieldValue;
                }

                function extractParams(data, params, actionParams) {
                    var ids = {}, paramKey;
                    params = extend({}, params);
                    actionParams = extend({}, paramDefaults, actionParams);
                    forEach(actionParams, function (value, key) {
                        if (isFunction(value)) { value = value(); }
                        paramKey = value.charAt && value.charAt(0) === '@' ? value.substr(1) : undefined;
                        if (paramKey && params[paramKey] && key !== paramKey) {
                            params[key] = params[paramKey];
                            delete params[paramKey];
                        }
                        ids[key] = paramKey ? getter(data, paramKey) : value;
                    });
                    return extend(ids, params);
                }

                function validateField(resource, validator, value) {
                    var func, validatorName, validatorArgs;
                    if (validator instanceof Function) {
                        return validator(resource, value);
                    }
                    // Built-in validators
                    else if (_.isObject(validator)) {
                        validatorName = _.keys(validator)[0];
                        validatorArgs = angular.copy(validator[validatorName]);
                        func = defaultValidators[validatorName];

                        if (_.isUndefined(func)) {
                            throw new Error('Unknown validator');
                        } else {
                            if (!(validatorArgs instanceof Array)) {
                                validatorArgs = [validatorArgs];
                            }
                            validatorArgs.unshift(value);
                            validatorArgs.unshift(resource);
                            return func.apply(window, validatorArgs);
                        }
                    } else if (typeof validator === 'string') {
                        func = defaultValidators[validator];
                        if (_.isUndefined(func)) {
                            throw new Error('Unkown Validator');
                        } else {
                            return func(resource, value);
                        }
                    }
                }

                function validateResource(resource, validators, field) {
                    var resourceErrors = {};

                    resource.$valid = true;
                    _.each(validators, function (fieldValidators, fieldName) {
                        if (field && field !== fieldName) { return; }
                        var fieldErrors = {};
                        _.each(fieldValidators, function (validator) {
                            var result = validateField(resource, validator, resource[fieldName]);
                            if (result !== true) {
                                fieldErrors[result] = true;
                            }
                        });
                        if (!_.isEmpty(fieldErrors)) {
                            resourceErrors[fieldName] = fieldErrors;
                        }
                    });

                    if (!_.isEmpty(resourceErrors) && !field) {
                        resource.$valid = false;
                        resource.$errors = resourceErrors;
                    } else if (field) {
                        resource.$errors = resource.$errors || {};
                        if (field in resourceErrors) {
                            resource.$valid = false;
                            resource.$errors[field] = resourceErrors[field];
                        } else {
                            delete resource.$errors[field];
                        }
                        if (!_.keys(resource.$errors).length) {
                            resource.$valid = true;
                            delete resource.$errors;
                        }
                    } else {
                        resource.$valid = true;
                        delete resource.$errors;
                    }

                    return resource.$valid;
                }

                function defaultResponseInterceptor(response) {
                    return response.resource;
                }

                function notifyObservers(resource, eventName, data) {
                    if (observers || resource.$$instanceObservers) {
                        var classLevelObservers = observers && observers[eventName] || [],
                            instanceObservers = resource.$$instanceObservers &&
                                resource.$$instanceObservers[eventName] ||
                                [];

                        classLevelObservers.concat(instanceObservers).forEach(function (obs) {
                            obs.apply(resource, [data]);
                        });
                    }
                }

                // TODO jchamizo: assuming you do a get with some params given it should
                // add them to the resulting resource even if they are not returned from the
                // server to keep track of those params needed to its identification?
                // **** builder param only used for internal needs
                function Resource(resource, builder) {
                    var self = this,
                        parentConstructor = !builder,
                        resource_uri,
                        url;

                    // builder is an argument we dont want to offer in the signature
                    // since it will be used only for internal issues (solving problems
                    // with circular dependencies
                    builder = builder || [];

                    // if the resource is instantiated with an String we asume its
                    // a resource URI so we try to decode the URL and instantiate
                    // the resource with the params provided
                    if (isString(resource)) {
                        resource_uri = resource;
                        resource = route.decodeUrlParams(resource_uri);
                        resource.resource_uri = formatUri(resource_uri);
                    } else if (isObject(resource) && !resource.resource_uri) {
                        // if the resource does not provide resource_uri we try to get
                        // it based on the rest of the structure
                        url = route.getUrl(resource);
                        if (url) { resource.resource_uri = url; }
                    }

                    self.$watch('resource_uri', function (prop, oldValue, newValue) {
                        return formatUri(newValue);
                    });

                    // extend(self, resource || {});
                    shallowClearAndCopy(resource || {}, self);
                    preInitFunction.apply(self);

                    // checking if element is cached before
                    if (cache && this.resource_uri && cache.get(this.resource_uri)) {
                        throw 'Trying to instantiate an existing model [' +
                            this.resource_uri + '], use getOrCreate instead.';
                    }

                    if (fields) {
                        // if fields is defined then try to instantiate and use the definition for
                        // each field defined for the resource will be watched to define dirty
                        // fields and instantiate them properly
                        forEach(fields, function (field, fieldName) {
                            self[fieldName] = initializeField(
                                self,
                                self[fieldName],
                                fieldName,
                                builder
                            );

                            if (self[fieldName]) {
                                builder.push({
                                    object: self,
                                    field: fieldName,
                                    value: self[fieldName]
                                });
                            }

                            // creating watchers to all the fields to keep track of changes
                            // in any of them
                            self.$watch(fieldName, function (prop, oldValue, newValue) {
                                newValue = initializeField(self, newValue, prop);
                                if (oldValue !== newValue && !fields[fieldName].avoidDump) {
                                    self.$dirty = self.$dirty || {};

                                    self.$dirty[prop] = newValue;
                                }
                                return newValue;
                            });
                        });

                        // deleting dirty since cannot avoid _.observe setting it to dirty in initialization
                        delete self.$dirty;
                    }
                    initFunction.apply(self);

                    if (cache && !_.isUndefined(this.resource_uri) && parentConstructor) {
                        updateCache(this);
                    }

                    if (parentConstructor) {
                        angular.forEach(builder, function (element) {
                            if (element.value && element.value.$cache) {
                                element.object[element.field] = updateCache(element.value);
                            } else if (element.value && element.value instanceof Array) {
                                angular.forEach(element.value, function (subelem, index) {
                                    element.object[element.field][index] = updateCache(subelem);
                                });
                            }
                        });
                    }
                }

                Resource.$fields = fields;

                if (classProperties) {
                    Resource.prototype.$static = {};
                    forEach(classProperties, function(prop, propName) {
                        Resource['$' + propName] = prop;
                        Resource.prototype.$static['$' + propName] = prop;
                    });
                }

                // method to use to create new resources making sure there is
                // no instance created with same resource URI.
                // This allows to only have an instance in the application to represent
                // any resource
                Resource.getOrCreate = function (data, builder) {
                    data = data || {};
                    var resource, resource_uri;
                    if (cache) {
                        resource_uri = _.isString(data) ? data : data.resource_uri || route.getUrl(data);
                        resource = resource_uri && cache.get(resource_uri);
                    }

                    // cleanup
                    if (!_.isString(data)) {
                        data = _.omit(data, _.isNull);
                    }

                    if (!resource) {
                        resource = new Resource(data, builder);
                    } else if (!_.isString(data)) {
                        // updating in case some changes were retrieved from server
                        resource = updateCache(resource, data);
                    }
                    return resource;
                };

                Resource.getCachedResource = function (data) {
                    data = data || {};
                    var resource, resource_uri;
                    if (cache) {
                        resource_uri = _.isString(data) ? data : data.resource_uri || route.getUrl(data);
                        resource = resource_uri && cache.get(resource_uri);
                    }
                    return resource;
                };

                Resource.getBaseUrl = function () {
                    var config = {};
                    route.setUrlParams(config, {});
                    return config.url;
                };

                Resource.$fields = fields;

                extend(Resource.prototype, {
                    $isDirty: function () {
                        return this.$dirty !== undefined;
                    },
                    // method to prepare info to send to server. If data is provided we use those
                    // fields as reference to prepare data to send. We do so because in some parts
                    // of the resource it may be checking if there are dirty fields.
                    $dumpData: function (data, action, params) {
                        var self = this;

                        data = data || self;
                        if (data === undefined) { return data; }

                        var dumpedData = {},
                            url;
                        if (fields) {
                            forEach(fields, function (field, fieldName) {
                                var fieldValue = data[fieldName];
                                if (field.avoidDump || _.isUndefined(fieldValue)) {
                                    return;
                                }

                                if (field.isArray) { // fieldValue have to be an Array!
                                    var elements = dumpedData[fieldName] = dumpedData[fieldName] || [];
                                    forEach(fieldValue, function (element, index) {
                                        elements[index] = isFunction(field.dumper) ?
                                                field.dumper.apply(dumpedData, [element]) :
                                                element;
                                        if (field.resource) {
                                            elements[index] = element.resource_uri || element.$dumpData();
                                        }
                                    });

                                } else {
                                    dumpedData[fieldName] = isFunction(field.dumper) ?
                                            field.dumper.apply(dumpedData, [fieldValue]) :
                                            fieldValue;

                                    if (field.resource) {
                                        // TODO jchamizo: do test of this
                                        if (fieldValue && !(fieldValue instanceof field.resource)) {
                                            fieldValue = field.resource.getOrCreate(fieldValue);
                                        }
                                        if (!fieldValue || !fieldValue.resource_uri && field.force_populate) {
                                            dumpedData[fieldName] = fieldValue.$dumpData(fieldValue, action, params);
                                        } else if (!fieldValue.resource_uri && !field.force_populate) {
                                            delete dumpedData[fieldName];
                                        } else if (fieldValue.resource_uri){
                                            dumpedData[fieldName] = field.populate ?
                                                {resource_uri: fieldValue.resource_uri} :
                                                fieldValue.resource_uri;
                                        }
                                    }

                                }
                            });
                        } else {
                            dumpedData = data;
                        }

                        // Per action defined dumpers will always overwrite global defined ones
                        if (action && action.dumper && typeof action.dumper === 'function') {
                            dumpedData = action.dumper.apply(self, [dumpedData, params]);
                        } else if (resourceDumper && typeof resourceDumper === 'function') {
                            dumpedData = resourceDumper.apply(self, [dumpedData, params]);
                        }

                        if (!self.resource_uri) {
                            url = route.getUrl(self);
                            if (url) {
                                dumpedData.resource_uri = url;
                            }
                        }

                        return _.pick(dumpedData, function (value, key) {
                            return key.charAt(0) !== '$';
                        });
                    },
                    $pristine: function () {
                        return _.extend(shallowClearAndCopy(this), this.$isDirty() ? this.$dirty : {});
                    },
                    $validate: function (field) {
                        return validateResource(this, validators, field);
                    },
                    $addObserver: function (eventName, observer) {
                        this.$$instanceObservers = this.$$instanceObservers || {};
                        this.$$instanceObservers[eventName] = this.$$instanceObservers[eventName] || [];
                        this.$$instanceObservers[eventName].push(observer);
                    },
                    $cache: cache
                });

                if (config.methods) {
                    angular.extend(Resource.prototype, config.methods);
                }

                forEach(actions, function (action, name) {
                    action.method = angular.uppercase(action.method);
                    var hasBody = action.method === 'POST' ||
                            action.method === 'PUT' ||
                            action.method === 'PATCH',
                        next,
                        previous;

                    Resource[name] = function (a1, a2, a3, a4) {
                        var params = {},
                            data,
                            value,
                            cached,
                            promise,
                            emptyRequest,
                            deferred,
                            isInstanceCall,
                            beforeEventName,
                            afterEventName,
                            responseInterceptor,
                            responseErrorInterceptor,
                            success = noop,
                            error = function (response) {
                                // TEMPORAL CHANGE FOR NOT HAVING TO WRITE THE ERROR FUNCTION ALL THE TIME
                                // console.error('ERROR', response);
                                return response;
                            },
                            httpConfig = {};

                        if (_.isArray(defaultHeaders)) {
                            httpConfig.headers = $injector.invoke(defaultHeaders);
                        } else if (_.isObject(defaultHeaders)) {
                            httpConfig.headers = defaultHeaders;
                        }

                        switch (arguments.length) {
                        case 4:
                            params = a1;
                            data = a2;
                            error = a4;
                            success = a3;
                            break;
                        case 3:
                            if (isFunction(a2)) {
                                if (hasBody) {
                                    data = a1;
                                } else {
                                    params = a1;
                                }
                                success = a2;
                                error = a3;
                            } else {
                                params = a1;
                                data = a2;
                                success = a3;
                            }
                            break;
                        case 2:
                            if (isFunction(a1)) {
                                success = a1;
                                error = a2;
                            } else if (isFunction(a2)) {
                                if (hasBody) {
                                    data = a1;
                                } else {
                                    params = a1;
                                }
                                success = a2;
                            } else {
                                params = a1;
                                data = a2;
                            }
                            break;
                        case 1:
                            if (isFunction(a1)) {
                                success = a1;
                            } else if (hasBody) {
                                data = a1;
                            } else {
                                params = a1;
                            }
                            break;
                        case 0:
                            break;
                        default:
                            throw $resourceMinErr (
                                'badargs',
                                'Expected between 0-4 arguments [params, data, success, error], got ' +
                                    arguments.length + ' arguments.'
                            );
                        }

                        forEach(action, function (value, key) {
                            if (key !== 'params' && key !== 'isArray' && key !== 'interceptor') {
                                httpConfig[key] = copy(value);
                            }
                        });

                        isInstanceCall = this instanceof Resource;
                        value = isInstanceCall ? this : (action.isArray ? [] : {});
                        beforeEventName = 'before' + name.charAt(0).toUpperCase() + name.substring(1);
                        afterEventName = 'after' + name.charAt(0).toUpperCase() + name.substring(1);

                        responseInterceptor = action.interceptor ?
                            action.interceptor.response :
                            defaultResponseInterceptor;

                        responseErrorInterceptor = action.interceptor ?
                            action.interceptor.responseError :
                            undefined;

                        // Not sending invalid data to the server !!
                        if (isInstanceCall && hasBody && !value.$validate()) {
                            throw new Error('Trying to save an invalid instance');
                        }

                        notifyObservers(value, beforeEventName, data);

                        // dumping data on request in case necessary based on dumpers defined in $field
                        httpConfig.data = hasBody &&
                            Resource.prototype.$dumpData.apply(this, [data, action, params]);

                        if (!params || !params.url) {
                            // if url is provided can only be getNext or getPrevious
                            route.setUrlParams(httpConfig, extend(
                                {resource_uri: this.resource_uri},
                                extractParams(data, params, action.params || {})
                            ));
                        } else if (params.url) {
                            httpConfig.url = params.url;
                        }

                        cached = cache && !action.isArray && cache.get(httpConfig.url);

                        value = cached || (
                            this instanceof Resource ? this : (
                                action.isArray ? [] : Resource.getOrCreate(data)
                            )
                        );

                        if (!cached || action.method !== 'GET' || action.ignoreCache) {
                            emptyRequest = _.isEmpty(httpConfig.data);
                            if ((hasBody && !emptyRequest) || !hasBody) {
                                promise = $http(httpConfig);
                            } else {
                                deferred = $q.defer();
                                promise = deferred.promise;
                                deferred.resolve({resource: value, data: {}});
                            }
                        } else {
                            deferred = $q.defer();
                            promise = deferred.promise;
                            deferred.resolve({ resource: cached, isCached: true });
                        }

                        promise.then(function (response) {
                            if (response.isCached && response.resource !== value) {
                                // TODO jchamizo needs a test with cache + nested resources
                                extend(value, response.resource);
                            }
                            var data = response.data;

                            if (data && angular.isObject(data)) {
                                if (action.isArray) {
                                    value.length = 0;
                                    response.context = {};
                                    response.context.count = data.count;
                                    response.context.next = data.next;
                                    response.context.previous = data.previous;
                                    response.context.url = httpConfig.url;
                                    forEach(data.results, function (item) {
                                        var resource = Resource.getOrCreate(item);
                                        resource.resource_uri = resource.resource_uri || route.getUrl(resource);
                                        resource = updateCache(resource);
                                        value.push(resource);
                                    });
                                } else {
                                    // done this way instead of copying to activate watchers
                                    data = _.omit(data, _.isNull);
                                    extend(value, data);
                                    value.resource_uri = value.resource_uri || route.getUrl(value);

                                    initFunction.apply(value);
                                    preInitFunction.apply(value);

                                    delete value.$dirty; // deleting element of dirty
                                    value = updateCache(value, data);
                                }
                            }

                            if (action.method === 'DELETE') {
                                value.resource_uri = value.resource_uri || route.getUrl(value);
                                if (value.resource_uri && value.$cache) {
                                    value.$cache.remove(value.resource_uri);
                                }
                                forEach(value, function (resValue, resName) {
                                    if (resName.charAt && resName.charAt(0) !== '$') {
                                        delete value[resName];
                                    }
                                });
                            }

                            value.$resolved = true;

                            (success || noop)(value, response.headers);
                            response.resource = value;

                            _.each(action.isArray ? value : [value], function (resource) {
                                notifyObservers(resource, afterEventName);
                            });

                            return response;

                        }).catch(function (response) {
                            value.$resolved = true;
                            (error || noop)(response);
                            return $q.reject(response);
                        });

                        return promise;
                    };

                    // avoid creating inner method for GET actions
                    // since it can get some pointer problems when dealing with
                    // cache.
                    Resource.prototype['$' + name] = function (a1, a2, a3) {
                        var params = extractParams(this, undefined, action.params),
                            success = noop,
                            error,
                            data;


                        switch (arguments.length) {
                        case 3:
                            params = a1;
                            success = a2;
                            error = a3;
                            break;
                        case 2:
                        case 1:
                            if (isFunction(a1)) {
                                success = a1;
                                error = a2;
                            } else {
                                params = a1;
                                success = a2 || noop;
                            }
                            break;
                        case 0:
                            break;
                        default:
                            throw 'Expected between 1-3 arguments [params, success, error], got ' +
                                arguments.length + ' arguments.';
                        }
                        if (hasBody) {
                            // use dirty only for PATCH methods
                            data = (_.keys(fields).length > 0 && action.method === 'PATCH') ?
                                    this.$dirty || {} :
                                    this;
                        }
                        return Resource[name].call(this, params, data, success, error);
                    };
                    if (action.method === 'GET' && action.isArray) {
                        next = name + 'Next';
                        previous = name + 'Previous';
                        Resource[next] = function (context, success, error) {
                            context = context || {};
                            var nextUrl = context.next;
                            if (nextUrl) {
                                return Resource[name]({url: nextUrl}, success, error);
                            }
                            return $q.when(true).then(
                                function () {
                                    return {
                                        nextSkipped: true
                                    };
                                }
                            );
                        };
                        Resource[previous] = function (context, success, error) {
                            var previousUrl = context.previous;
                            if (previousUrl) {
                                return Resource[name]({url: previousUrl}, success, error);
                            }
                            return null;
                        };
                    }
                });

                Resource.bind = function (additionalParamDefaults) {
                    return resourceFactory({
                        url: url,
                        paramDefaults: extend({}, paramDefaults, additionalParamDefaults)
                    }, actions, fields, cache);
                };

                Object.defineProperty(Resource.prototype, '$watch', {
                    enumerable: false,
                    configurable: true,
                    writable: false,
                    value: function (prop, handler) {
                        var oldval = this[prop],
                            newval = oldval,
                            getter = function () {
                                return newval;
                            },
                            setter = function (val) {
                                oldval = newval;
                                newval = handler.call(this, prop, oldval, val);
                                return newval;
                            };

                        if (delete this[prop]) { // can't watch constants
                            Object.defineProperty(this, prop, {
                                get: getter,
                                set: setter,
                                enumerable: true,
                                configurable: true
                            });
                        }
                    }
                });

                if (fields) {
                    forEach(fields, function (value) {
                        var resource, inverse;
                        if (_.isObject(value) && value.resource) {
                            if (value.resource === '$self') {
                                value.resource = Resource;
                            }
                            if (value.inverseField) {
                                resource = value.resource;
                                inverse = value.inverseField;
                                resource.$fields[inverse.name] = _.extend(
                                    {},
                                    _.omit(inverse, 'name'),
                                    { resource: Resource }
                                );
                            }
                        }
                    });
                }

                return Resource;
            }

            return resourceFactory;
        }
    ];
}).directive('ecResourceValidator', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: { resource: '=ecResourceValidator', ngModel: '=' },
        link: function (scope, elem, attr, ctrl) {
            var watchers = [], name = attr.name;
            watchers.push(
                scope.$watch(
                    function () {
                        return scope.resource && scope.resource.$errors && scope.resource.$errors[name];
                    },
                    function (errors) {
                        _.each(ctrl.$error, function (value, key) {
                            ctrl.$setValidity(key, true);
                        });
                        if (errors && !_.isEmpty(errors)) {
                            _.each(errors, function (val, errorName) {
                                ctrl.$setValidity(errorName, false);
                            });
                        }
                    }
                )
            );

            watchers.push(
                scope.$watch('ngModel', function () {
                    if (ctrl.$dirty) {
                        scope.resource.$validate(name);
                    }
                })
            );

            elem.bind('blur', function () {
                scope.resource.$validate(name);
            });

            scope.$on('$destroy', function () {
                elem.unbind('blur');
                _.each(watchers, function (watcher) {
                    watcher();
                });
            });
        }
    };
});



// WEBPACK FOOTER //
// ./scripts/helpers/ec-resource.js